<div class="mwp-modal">
    <div class="header">
        <mwp-text-translate text="Choose Language" jsonKey="chooseLanguageTitle" />
    </div>
    <div class="body pb-0">
        <mwp-translation />
    </div>
    <div class="footer">
        <button class="mwp-button-secondary w-100" (click)="close()">
            <mwp-text-translate text="CANCEL" jsonKey="cancel" />
        </button>
    </div>
</div>